import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-lock",
  templateUrl: "./lock.component.html",
  styleUrls: ["./lock.component.scss"],
})
export class LockComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
